import React from "react";

const CheckInput = props => {

    return (
        <input type="checkbox" className={"checkbox " + props.className} onChange={e => props.set(e.target.checked)} checked={props.v} />
    );
}

export default CheckInput;